import { Badge, fmt, type Column } from "@nabble/ui";
import type { AdminDataRequest } from "../../../api/adminDataRequests";
import { isAnswered, KIND_LABEL_ADMIN, STATUS_LABEL, STATUS_TONE } from "../../../model/dataRequests";
import { Deadline } from "./Deadline";

/** The columns of the data requests list; `open` shows one request in the drawer. */
export function dataRequestColumns(open: (request: AdminDataRequest) => void): Column<AdminDataRequest>[] {
  return [
    {
      key: "userName",
      label: "Person",
      minWidth: 220,
      text: (r) => `${r.userName} (${r.userEmail})`,
      render: (r) => (
        <div className="nb-cell-stack">
          <strong title={r.userName}>{r.userName}</strong>
          <span className="nb-cell-sub" title={r.userEmail}>
            {r.userEmail}
          </span>
        </div>
      ),
    },
    { key: "kind", label: "Request", minWidth: 200, text: (r) => KIND_LABEL_ADMIN[r.kind] },
    { key: "createdAt", label: "Sent", type: "date", width: 130, text: (r) => fmt.date(r.createdAt) },
    {
      key: "dueAt",
      label: "Deadline",
      width: 210,
      text: (r) => fmt.date(r.dueAt),
      render: (r) => <Deadline request={r} />,
    },
    {
      key: "status",
      label: "Status",
      width: 130,
      text: (r) => STATUS_LABEL[r.status],
      render: (r) => <Badge label={STATUS_LABEL[r.status]} tone={STATUS_TONE[r.status]} />,
    },
    {
      key: "actions",
      label: "Actions",
      type: "actions",
      width: 64,
      actions: (r) => [{ label: isAnswered(r.status) ? "See request" : "Open request", icon: "eye", inline: true, onSelect: () => open(r) }],
    },
  ];
}
